import styled, { css } from 'styled-components';
import { SectionHeading, SectionWrapper } from './Section';

type ProcessedMessageProps = {
  heading: string;
  children: React.ReactNode;
  error?: boolean;
};

const SuccessIcon = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.main.accent};
    font-size: 45px !important;
  `
);

const SuccessHeading = styled((props) => <SectionHeading {...props} />)`
  color: ${({ theme }) => theme.colors.main.accent};
`;

const ErrorIcon = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.main.error};
    font-size: 45px !important;
  `
);

const ErrorHeading = styled((props) => <SectionHeading {...props} />)`
  color: ${({ theme }) => theme.colors.main.error};
`;

const ProcessedMessage = ({
  heading,
  error,
  children
}: ProcessedMessageProps) => {
  return (
    <SectionWrapper>
      {!error && (
        <>
          <SuccessIcon className="material-symbols-rounded">
            sentiment_very_satisfied
          </SuccessIcon>
          <SuccessHeading>{heading}</SuccessHeading>
        </>
      )}
      {error && (
        <>
          <ErrorIcon className="material-symbols-rounded">
            sentiment_dissatisfied
          </ErrorIcon>
          <ErrorHeading>{heading}</ErrorHeading>
        </>
      )}

      <>{children}</>
    </SectionWrapper>
  );
};

export { ProcessedMessage };
